export const headerNavigation = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about-us" },
  { label: "Services", to: "/services" },
  // { label: "Blogs", to: "/blog" },
  { label: "Contact", to: "/contact-us" },
];

export const serviceDropdownItems = [
  {
    title: "Neurofeedback & Beyond",
    link: "/services/neurofeedback",
    icon: "/img/services_icon/neurofeedback.svg",
    children: [
      {
        title: "Brain Zen Pro",
        link: "/services/brain-zen-pro",
        type: "nested",
      },
      {
        title: "Memory Care & Brain Brightening",
        link: "/services/brain-memory-care",
        type: "nested",
      },
    ],
  },
  {
    title: "Allergy Testing & Immunotherapy",
    link: "/services/allergy-testing",
    icon: "/img/services_icon/allergy.svg",
  },
  {
    title: "Medical Billing",
    link: "/services/medical-billing-services",
    icon: "/img/services_icon/rcm.svg",
  },
  {
    title: "Mini C-Arm Injections",
    link: "/services/osteoarthritis-injections",
    icon: "/img/services_icon/mini-c-arm.svg",
  },
  {
    title: "Advanced Wound Care",
    link: "/services/advance-wound-care",
    icon: "/img/services_icon/wound-care.svg",
  },
  {
    title: "Flow 7 Testing Dysfunction",
    link: "/services/tm-flow-testing-dysfunction",
    icon: "/img/services_icon/testing.svg",
  },
  {
    title: "In-House Lab Services",
    link: "/services/in-house-lab-services",
    icon: "/img/services_icon/lab-services.svg",
  },
  {
    title: "Toxicology Laboratory Solutions",
    link: "/services/toxicology-laboratory-solutions",
    icon: "/img/services_icon/tls.svg",
  },
  {
    title: "Marketing Services",
    link: "/services/marketing-services",
    icon: "/img/services_icon/marketing.svg",
  },
  {
    title: "Transcranial Magnetic Stimulation",
    link: "/services/transcranial-magnetic-stimulation",
    icon: "/img/services_icon/tms.svg",
  },
  {
    title: "EMR Subscription",
    link: "/services/emr-subscription",
    icon: "/img/services_icon/emr.svg",
  },
];

export const footerQuickLinks = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about-us" },
  { label: "Contact Us", to: "/contact-us" },
  { label: "FAQs", to: "/frequently-asked-questions" },
  { label: "Terms & Conditions", to: "/terms-and-conditions" },
];

export const footerServices = [
  { label: "Neurofeedback & Beyond", to: "/services/neurofeedback" },
  { label: "Allergy Testing & Immunotherapy", to: "/services/allergy-testing" },
  { label: "Medical Billing", to: "/services/medical-billing-services" },
  { label: "Mini C-Arm Injections", to: "/services/osteoarthritis-injections" },
  { label: "Advanced Wound Care", to: "/services/advance-wound-care" },
  { label: "Flow 7 Testing Dysfunction", to: "/services/tm-flow-testing-dysfunction" },
  { label: "In-House Lab Services", to: "/services/in-house-lab-services" },
];
